var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showStripePayment)?_c('div',[_c('h5',{staticClass:"text-divider"}),_c('div',{attrs:{"id":"payment-request-button"}}),(
      _vm.customGooglePayImage &&
      _vm.enableGooglePay &&
      _vm.canGooglePay
    )?_c('div',{staticClass:"gpay-gift-custom-button",on:{"click":function($event){return _vm.clickCustomButton('google')}}},[(_vm.isGift)?_c('img',{attrs:{"src":require("../../../../assets/gpay.svg")}}):_c('img',{attrs:{"src":require("../../../../assets/Google_Pay_Logo.svg")}})]):_vm._e(),(
      _vm.customApplePayImage &&
      _vm.enableApplePay &&
      _vm.canApplePay
    )?_c('div',{staticClass:"apay-gift-custom-button",on:{"click":function($event){return _vm.clickCustomButton('apple')}}}):_vm._e(),_c('div',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.error))]),_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h5',{staticClass:"text-divider"},[_c('span',[_vm._v("Or Pay with Card")])])
}]

export { render, staticRenderFns }